const CHOICE_NATURES: readonly string[] = ['choice', 'multiple_choice'];

/** True for the natures whose value is picked among options. */
function isChoiceNature(nature: string): boolean {
	return CHOICE_NATURES.includes(nature);
}

export default isChoiceNature;
